// Utilities
import {convertToButton} from '../utilities/utilities';

const settings = {
    classNames: {
        // All statue screens contain hotspots
        hotspot: 'hotspot',
        hotspotSelected: 'hotspot--selected',
    },
};

/**
 * Hotspot buttons that appear throughout the site - the details around
 * only allowing one to be selected at a time, making related content
 * appear when selected, etc. are handled in the classes that make use
 * of this (e.g., statue-section.js, home-statues.js, etc.)
 */
export default class HotSpot {
    constructor(button, callbacks = {}) {
        // Convert the button to a <button> element if the HTML isn't
        // already coded as such - this allows it to be navigated to
        // via the keyboard
        button = convertToButton(button);

        this.button = button;
        this.callbacks = callbacks;
        this.selected = false;

        this.cardName = button.getAttribute('data-card');
        if (this.cardName) {
            this.card = document.querySelector(`:not(.${settings.classNames.hotspot})[data-card="${this.cardName}"]`);
        }

        const clickCallback = function(event) {
            event.preventDefault();
            event.stopPropagation();

            this.select(event instanceof KeyboardEvent);
        }.bind(this);

        button.addEventListener(
            'keydown',
            (event) => {
                if (event.key != 'Enter') {
                    return;
                }

                clickCallback(event);
            },
        );

        button.addEventListener('click', clickCallback);

        // This causes unintended clicks too easily
        // button.addEventListener('touchstart', clickCallback);
    }

    static get classNames() {
        return settings.classNames;
    }

    select(keyboardEvent) {
        if (this.selected) {
            // EDIT: creative wants subsequent clicks on these to perform a deselect
            // return;

            this.deselect(keyboardEvent);
            return;
        }

        this.selected = true;
        this.button.classList.add(settings.classNames.hotspotSelected);

        if (this.callbacks.onSelect) {
            this.callbacks.onSelect(this, keyboardEvent);
        }
    }

    deselect(keyboardEvent) {
        if (!this.selected) {
            return;
        }

        this.selected = false;
        this.button.classList.remove(settings.classNames.hotspotSelected);

        if (this.callbacks.onDeselect) {
            this.callbacks.onDeselect(this, keyboardEvent);
        }
    }
}
